<ps-ui-loader></ps-ui-loader>
<ps-ui-cpi-override-warning
  *ngIf="requireBuyerCpiConfirmation && !buyerCpiConfirmation.state"
  (confirm)="onBuyerCpiConfirmation($event)"
  [newCpi]="newCpiConfirmation"
  [surveyId]="surveyId"
></ps-ui-cpi-override-warning>
<ps-ui-create-survey-info-header
  [surveyDetails]="surveyDetails"
></ps-ui-create-survey-info-header>
<main class="container">
  <form
    class="create_survey_form"
    [formGroup]="form"
    (keydown.enter)="$event.preventDefault()"
  >
    <!-- Metadata -->
    <div class="metadata-form">
      <div
        *ngIf="enableMarginForOperatorBuyer && templateEnable"
        class="row survey_form"
      >
        <div class="row col-md-12" style="display: flex; flex-direction: row">
          <ng-container *ngTemplateOutlet="WASPTemplate"></ng-container>
        </div>
      </div>
      <div [ngClass]="{ 'metadata-secton': this.surveyDetails?.mc?.SVP }">
        <div class="metadata-secton-label" *ngIf="this.surveyDetails?.mc?.SVP">
          <label>
            COMMON FOR ALL LOCALES
            <span class="fw-normal">
              (Any changes will be applied to all locales)
            </span>
          </label>
        </div>

        <div class="row survey_form">
          <div
            [ngClass]="
              enableMarginForOperatorBuyer && !templateEnable
                ? 'col-md-4 form-group '
                : 'col-md-8 form-group '
            "
          >
            <label>SURVEY TITLE</label>
            <input
              type="text"
              class="form-control survey-style"
              formControlName="surveyTitle"
              (focusout)="autoSaveSurveyInDraft()"
              (change)="surveyTitleChanged()"
              [attr.disabled]="isTCSPAEditMode ? true : null"
            />
          </div>
          <div
            *ngIf="enableMarginForOperatorBuyer && !templateEnable"
            class="row col-md-8"
            style="display: flex; flex-direction: row"
          >
            <ng-container *ngTemplateOutlet="WASPTemplate"></ng-container>
          </div>

          <div
            *ngIf="enableMarginForOperatorBuyer && !templateEnable"
            class="col-md-2"
          ></div>

          <div
            *ngIf="showCategory"
            class="col-md-4 form-group category-dropdown"
          >
            <div *ngIf="!isServiceBuyerOperation"></div>
            <label>CATEGORY</label>
            <ps-ui-select-dropdown
              [dropdownItems]="categories"
              [field]="'name'"
              [clearSearch]="false"
              labelNone="Select Category"
              labelAlignment="start"
              formControlName="selectedCategory"
              (selectedItem)="selectCategory($event)"
              [disabled]="isLiveSurveyEdit || isTCSPAEditMode"
            >
            </ps-ui-select-dropdown>
          </div>
          <div
            *ngIf="templateEnable"
            class="col-md-4 form-group category-dropdown"
          >
            <div class="template-label-options">
              <label class="template-label">TEMPLATE</label>
              <a
                *ngIf="!!selectedTemplateResponse?.template"
                href=""
                (click)="updateQualificationsVisibility($event)"
                >{{
                  showAllQualifications
                    ? 'Hide Qualifications'
                    : 'Show All Qualifications'
                }}</a
              >
            </div>
            <ps-ui-tree-dropdown
              [label]="
                this.selectedTemplateResponse &&
                this.selectedTemplateResponse.template &&
                this.selectedTemplateResponse.template.name
                  ? this.selectedTemplateResponse.template.name
                  : ''
              "
              [dropdownItems]="templates"
              [folderOption]="templateFolderOption"
              [fileOption]="templateOption"
              [maxDepth]="TEMPLATE_DROPDOWN_CONSTANTS.MAX_NAVIGATION_DEPTH"
              [disabled]="isLiveSurveyEdit || isSpecificAudienceTcSurvey"
              [isRemoveSelection]="isRemoveSelectedTemplate"
              formControlName="selectedTemplate"
              (selectFile)="selectTemplate($event)"
              (removeSelection)="removeSelectedTemplate()"
              (deleteTemplateItem)="deleteTemplate($event)"
              psUiGtagEvent
              trackOn="change"
              action="template"
              category="Tools"
              [params]="{ event_label: 'Template Selected/Removed' }"
            ></ps-ui-tree-dropdown>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="row survey_form double-line">
          <div class="col-md-4 col-lg-2 form-group">
            <label>COUNTRY</label>
            <ps-ui-select-dropdown
              [multi]="allowMultipleCountriesSelection"
              [dropdownItems]="countries"
              [field]="'name'"
              [clearSearch]="false"
              class="uppercase"
              labelNone="Select Country"
              labelAlignment="start"
              [disabled]="isEditMode || isTCSPAEditMode"
              formControlName="selectedCountries"
              (selectedItem)="selectCountry($event)"
              (selectedItems)="selectCountries($event)"
              [sortBySelected]="true"
              [orderBy]="'orderId'"
            >
            </ps-ui-select-dropdown>
          </div>
          <div class="col-md-4 col-lg-2 form-group">
            <label>LANGUAGE</label>
            <ps-ui-select-dropdown
              [multi]="allowMultipleCountriesSelection"
              [considerSingleSelectionAsAll]="
                considerSingleLanguageSelectionAsAll
              "
              [dropdownItems]="languages"
              [field]="'name'"
              [clearSearch]="false"
              class="uppercase"
              labelNone="Select Language"
              labelAlignment="start"
              formControlName="selectedLanguages"
              [disabled]="
                selectedCountries.length > 1 ||
                isLiveSurveyEdit ||
                isTCSPAEditMode
              "
              (selectedItem)="setLanguage($event, true)"
              (selectedItems)="selectLanguages($event)"
            >
            </ps-ui-select-dropdown>
          </div>
          <div class="col-md-4 col-lg-2 form-group completes-box">
            <label for="completes">
              Completes
              <span
                *ngIf="
                  selectedCountries.length > 1 || selectedLanguages.length > 1
                "
                class="setting-info"
              >
                <i class="fa fa-info-circle"></i>
                <p>
                  The number of completes is referring for each survey.<br />You
                  can check the total completes from the top bar menu
                </p>
              </span>
            </label>
            <input
              class="form-control survey-style"
              name="numberOfCompletes"
              type="number"
              formControlName="numberOfCompletes"
              (change)="changeInfields('numberOfCompletes')"
              oninput="if(this.value.length>6){ this.value = this.value.slice(0,6) }"
              (focusout)="autoSaveSurveyInDraft(); calculateTotalClicks()"
              psUiInputRestriction="[0-9]"
            />
            <span
              *ngIf="
                surveyDetails &&
                surveyDetails.ps_survey_status !== SURVEY_STATUS.DRAFT
              "
            >
              Fielded: {{ surveyDetails?.fielded }}
            </span>

            <span *ngIf="mcQBTotalCompletesText">
              {{ mcQBTotalCompletesText }}
            </span>
          </div>
          <div class="col-md-4 col-lg-2 form-group place_holder">
            <label>Length of Survey</label>
            <input
              type="number"
              class="form-control survey-style"
              [attr.disabled]="
                isLiveSurveyEdit || isTCSPAEditMode ? true : null
              "
              formControlName="lengthOfSurvey"
              oninput="if(this.value.length>2){ this.value = this.value.slice(0,2) }"
              (focusout)="autoSaveSurveyInDraft()"
              psUiInputRestriction="[0-9]"
            />
            <span>mins</span>
          </div>
          <div class="col-md-4 col-lg-2 form-group place_holder">
            <label>Incidence</label>
            <input
              type="number"
              class="form-control survey-style"
              [attr.disabled]="
                isLiveSurveyEdit || isTCSPAEditMode ? true : null
              "
              name="incidence"
              formControlName="incidence"
              oninput="if(this.value.length>2){ this.value = this.value.slice(0,2) }"
              (focusout)="autoSaveSurveyInDraft(); calculateTotalClicks()"
              psUiInputRestriction="[0-9]"
            />
            <span>%</span>
          </div>
          <div class="col-md-4 col-lg-2 form-group place_holder">
            <label for="field_time">FIELD TIME</label>
            <input
              type="number"
              class="form-control border-less-input survey-style"
              formControlName="fieldTime"
              (focusout)="autoSaveSurveyInDraft()"
              [attr.disabled]="isTCSPAEditMode ? true : null"
              psUiInputRestriction="[0-9]"
            />
            <span>days</span>
          </div>
        </div>
        <!-- WASP -->
        <ng-template #WASPTemplate>
          <div class="row col-md-7">
            <div class="col-md-4 form-group place_holder_before">
              <label>Buyer Cpi</label>
              <div class="position-relative">
                <span>{{ currencySymbol }}</span>
                <!--we need to have type text to get commas as valid numbers, otherwise the form give us null instead-->
                <input
                  [ngClass]="{ 'inactive-red': requireBuyerCpiConfirmation }"
                  type="text"
                  class="form-control survey-style"
                  formControlName="buyerCpiOverride"
                  (input)="validateBuyerCpi()"
                  psUiInputRestriction="[0-9\.,]"
                  (focusin)="getInitialValueState()"
                  (focusout)="calculateSuppCpiOverride()"
                  (change)="changeInfields('buyerCpiOverride')"
                />
              </div>
            </div>
            <div class="col-md-4 form-group place_holder_end">
              <label>Margin</label>
              <div
                class="position-relative non-applicable-label"
                *ngIf="manualScpiDisabled"
              >
                N/A
              </div>
              <div class="position-relative" *ngIf="!manualScpiDisabled">
                <input
                  [ngClass]="{ 'inactive-red': marginBelowAverage }"
                  type="number"
                  class="form-control survey-style"
                  formControlName="buyerMargin"
                  psUiMarginRange
                  (focusout)="calculateSuppCpiOverride()"
                  [attr.disabled]="
                    manualScpiDisabled || (isAntmanEnabled && isLiveSurveyEdit)
                      ? true
                      : null
                  "
                />
                <span>%</span>
              </div>
              <div
                *ngIf="showWarningModal && !manualScpiDisabled"
                ng-hide="properties.userAcceptedMargin"
              >
                <span id="margin-warning-div" class="bubble">
                  <button class="close-button-ps" (click)="hideWarningModal()">
                    <i class="fa fa-close icon-close"></i>
                    <span class="key-label close-label">esc</span>
                  </button>
                  <div class="clearfix"></div>
                  <div class="margin-confirm-div">
                    <p class="key_warning">WARNING !</p>
                    <p class="text-warning">
                      You have entered a Target Margin value that is below the
                      average Margin set for this account.
                    </p>
                    <p class="text-warning">
                      We recommend reviewing the Banked Margin for the project
                      before you confirm you want to proceed
                    </p>
                    <button
                      type="button"
                      class="btn btn-primary confirm-button"
                      (click)="userAcceptedMargin()"
                    >
                      Confirm
                    </button>
                  </div>
                </span>
                <div class="overlay"></div>
              </div>
            </div>
            <div
              class="col-md-4 form-group place_holder_before supplier-cpi-input"
            >
              <label>Scpi</label>
              <div
                class="position-relative non-applicable-label"
                *ngIf="manualScpiDisabled"
              >
                N/A
              </div>
              <div class="dollar-sign-scpi" *ngIf="!manualScpiDisabled">
                <span>
                  <!--PD-9295 always shows scpi in dollars-->
                  $
                </span>
                <input
                  type="number"
                  [readonly]="true"
                  class="form-control readonly-input"
                  formControlName="supplierCpiOverride"
                />
              </div>
            </div>
          </div>
          <div class="col-md-5" *ngIf="isServiceBuyerOperation">
            <ps-ui-epc
              [surveyId]="surveyId"
              [countryCode]="countryCode"
              [surveyGoal]="form.value.numberOfCompletes"
              [incidence]="form.value.incidence"
              [showActualEpc]="isEditMode"
              [cpi]="form.value.buyerCpiOverride"
              [margin]="form.value.buyerMargin"
            >
            </ps-ui-epc>
          </div>
        </ng-template>

        <div
          class="survey-form custom-toggle text-center"
          *ngIf="showClickBalance"
        >
          <span>Completes</span>
          <div class="custom-toggle-inner">
            <input
              type="checkbox"
              id="switch"
              [attr.disabled]="
                !form.value.numberOfCompletes ||
                !form.value.incidence ||
                isLiveSurveyEdit ||
                isTCChildSurvey === true ||
                isTCSPAEditMode
                  ? true
                  : null
              "
              formControlName="clickBalancing"
              (change)="calculateTotalClicks()"
            /><label
              for="switch"
              [ngClass]="{
                'disable-toggle': isLiveSurveyEdit
              }"
              >Toggle</label
            >
            <p>
              <span class="entrants-text"
                >Entrants: {{ totalClicks ? totalClicks : 'NA' }}</span
              >
            </p>
          </div>
          <span>Clicks</span>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'core-section': this.surveyDetails?.mc?.SVP }">
      <!-- Core Qualifications -->
      <div class="core-section-label" *ngIf="this.surveyDetails?.mc?.SVP">
        <label>
          SPECIFIC TO THE LOCALE
          <span class="fw-normal">
            (Any changes will be applied to
            {{ selectedCountry?.name }}
            <span class="p-1 language-icon">
              {{ selectedLanguage?.transalte_code | uppercase }}
            </span>
            )
          </span>
        </label>
      </div>
      <div class="row survey_form">
        <ng-container
          *ngFor="
            let qualification of visibleQualifications;
            trackBy: trackByQualificationCode
          "
        >
          <div
            *ngIf="!qualification.is_location"
            class="col-md-4 col-lg-3 form-group"
          >
            <div class="row">
              <div class="col-8">
                <label>
                  {{ qualification.qualification_name }}
                  <ng-container>
                    <div
                      class="setting-info"
                      *ngIf="isQualificationInUnicorn(qualification)"
                    >
                      <i
                        class="fa fa-exclamation-circle error-icon-impossible me-2"
                        aria-hidden="true"
                      >
                        <p>
                          <span>
                            {{
                              Constants.INFO_TEXT
                                .WHEN_QUALIFICATION_IS_PRESENT_IN_UNICORNS
                            }}
                          </span>
                        </p>
                      </i>
                    </div>
                  </ng-container>
                </label>
              </div>
              <div
                *ngIf="
                  hasQuotas(qualification) &&
                  !isChildrenQualification(qualification.qualification_code)
                "
                class="col-4 has-quota-label"
              >
                {{
                  qualification.hasNestedQuotas ? 'Auto Nested' : 'Has Quotas'
                }}
              </div>
              <div
                *ngIf="
                  hasQuotas(qualification) &&
                  isChildrenQualification(qualification.qualification_code)
                "
                class="col-7 has-quota-label-child"
              >
                {{
                  qualification.hasNestedQuotas
                    ? 'Auto Nested'
                    : 'Add Age/Gender Targeting'
                }}
              </div>
            </div>

            <ps-ui-multiselect-input-button
              *ngIf="
                qualification.render_type ===
                QUALIFICATIONS_RENDER_TYPE.MULTIPUNCH_DROPDOWN
              "
              [isMcSurvey]="isMcSurvey"
              [qualification]="qualification"
              [quotas]="qualification.quotas"
              [flexible]="qualification.flexible"
              [complete]="totalClicks || form.value.numberOfCompletes"
              [isAdvanceTargetingParent]="
                qualification.isAdvanceTargetingParent
              "
              [clickBalance]="form.value.clickBalancing"
              [changeCompletes]="changeQuotaDistribution"
              [isQlcLiveSurvey]="isQlcLiveSurvey"
              (selectionChange)="setCoreQualification($event)"
              (quotaChange)="setQuotas($event)"
              [hasNestedGroup]="hasNestedGroup"
              [isLiveSurveyEdit]="isLiveSurveyEdit"
              [disabled]="disableInputFields"
            >
            </ps-ui-multiselect-input-button>
            <ps-ui-range-input-button
              *ngIf="
                qualification.render_type === QUALIFICATIONS_RENDER_TYPE.RANGE
              "
              [isMcSurvey]="isMcSurvey"
              [qualification]="qualification"
              [quotas]="qualification.quotas"
              [flexible]="qualification.flexible"
              [complete]="totalClicks || form.value.numberOfCompletes"
              [clickBalance]="form.value.clickBalancing"
              [changeCompletes]="changeQuotaDistribution"
              [isQlcLiveSurvey]="isQlcLiveSurvey"
              (valueChange)="setRangeQualification($event)"
              (quotaChange)="setQuotas($event)"
              [hasNestedGroup]="hasNestedGroup"
              [isLiveSurveyEdit]="isLiveSurveyEdit"
              [disabled]="disableInputFields"
            ></ps-ui-range-input-button>
          </div>
        </ng-container>
      </div>
      <div class="cleardiv"></div>
      <!-- Advance Targating Qualifications -->
      <ng-template #advanceTargetingTemplate>
        <ng-container
          *ngIf="
            selectedCountries.length < 2 &&
            selectedLanguages.length < 2 &&
            (advanceTargetingQualifications?.length || showAllQualifications)
          "
        >
          <label
            >ADVANCED TARGETING
            <ng-container>
              <div
                class="setting-info"
                *ngIf="
                  isAdvanceQualificationInUnicorn(
                    advanceTargetingQualifications
                  )
                "
              >
                <i
                  class="fa fa-exclamation-circle error-icon-impossible me-2"
                  aria-hidden="true"
                >
                  <p>
                    <span>
                      {{
                        Constants.INFO_TEXT
                          .WHEN_QUALIFICATION_IS_PRESENT_IN_UNICORNS
                      }}
                    </span>
                  </p>
                </i>
              </div>
            </ng-container>
            <span
              *ngIf="advanceTargetingQualifications?.length"
              class="adv-qual-applied"
              >Applied</span
            ></label
          >
          <ps-ui-advance-targeting-qualification
            [advanceTargetingQualifications]="advanceTargetingQualifications"
            [complete]="totalClicks || form.value.numberOfCompletes"
            [changeCompletes]="changeQuotaDistribution"
            [isQlcLiveSurvey]="isQlcLiveSurvey"
            (qualificationAdded)="addAdvanceQualification($event)"
            (quotaChange)="setQuotas($event)"
            (setCoreQualificationIfDependent)="
              setCoreQualificationIfDependent($event)
            "
            [qualifications]="qualifications"
            [hasQuotas]="hasQuotas.bind(this)"
            [locale]="locale"
            [showAllQualifications]="showAllQualifications"
            [hasNestedGroup]="hasNestedGroup"
            [alwaysShowQualCodes]="alwaysShowQualCodes"
            [isLiveEditSurvey]="isLiveSurveyEdit"
          >
          </ps-ui-advance-targeting-qualification>
        </ng-container>
        <div class="cleardiv"></div>
      </ng-template>

      <!--NOTE: [PD-8834] allow all operators to access to advanced targeting question block-->
      <div *ngIf="userType === 'operator'; else advanceTargetingContent">
        <ng-container
          *ngTemplateOutlet="advanceTargetingTemplate"
        ></ng-container>
      </div>
      <ng-template #advanceTargetingContent>
        <div *psUiConfigEnabled="'advanceTarget'">
          <ng-container
            *ngTemplateOutlet="advanceTargetingTemplate"
          ></ng-container>
        </div>
      </ng-template>
      <!-- Location Qualifications -->
      <div *ngIf="visibleLocationTabs.length" class="location-div">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 set-location">
            <h4 class="set-location-header">
              SET LOCATION
              <ng-container>
                <div
                  class="setting-info"
                  *ngIf="isQualificationInUnicorn(locationQualification)"
                >
                  <i
                    class="fa fa-exclamation-circle error-icon-impossible me-2"
                    aria-hidden="true"
                  >
                    <p>
                      <span>{{
                        Constants.INFO_TEXT
                          .WHEN_QUALIFICATION_IS_PRESENT_IN_UNICORNS
                      }}</span>
                    </p>
                  </i>
                </div>
              </ng-container>
            </h4>
            <span *ngIf="locationQualification?.hasNestedQuotas"
              >AutoNested</span
            >
            <button
              type="button"
              class="btn btn-default btn-link clear-button"
              id="clrLocation"
              (click)="clearLocation()"
              [disabled]="isQlcLiveSurvey"
            >
              Clear Location
            </button>
          </div>
        </div>
        <ps-ui-tab-group
          [activeIndex]="activeTabIndex"
          (activeIndexChange)="setLocation($event, activeTabIndex)"
          [beforeTabChange]="checkSelectedLocations"
          class="ps-ui-tab-group-content"
        >
          <ps-ui-tab
            *ngFor="let tab of visibleLocationTabs; let i = index"
            [label]="tab.title"
            [icon]="
              i === activeTabIndex && getLocationConditionCodes().length
                ? 'check'
                : ''
            "
          >
            <ng-template psUiTabContent class="center-tab-content">
              <ng-container [ngSwitch]="tab.renderType">
                <ng-container
                  *ngSwitchCase="QUALIFICATIONS_RENDER_TYPE.MULTIPUNCH_LIST"
                >
                  <ps-ui-selectbox-location-qualification
                    *ngIf="locationQualification.is_location"
                    [complete]="totalClicks || form.value.numberOfCompletes"
                    [qualification]="locationQualification"
                    [quotas]="locationQualification.quotas"
                    [flexible]="locationQualification.flexible"
                    [changeCompletes]="changeQuotaDistribution"
                    [clickBalance]="form.value.clickBalancing"
                    [deleteQuotas]="deleteLocationQuotas"
                    [isQlcLiveSurvey]="isQlcLiveSurvey"
                    (selectionChange)="setLocationQualification($event)"
                    (quotaChange)="setQuotas($event)"
                    [hasNestedGroup]="hasNestedGroup"
                    [isLiveSurveyEdit]="isLiveSurveyEdit"
                    [isMcSurvey]="isMcSurvey"
                  >
                  </ps-ui-selectbox-location-qualification>
                </ng-container>
                <ng-container *ngSwitchCase="QUALIFICATIONS_RENDER_TYPE.SEARCH">
                  <ps-ui-search-location-qualification
                    *ngIf="locationQualification.is_location"
                    [complete]="totalClicks || form.value.numberOfCompletes"
                    [selectedCountry]="selectedCountryCode"
                    [selectedLanguage]="selectedLanguageCode"
                    [qualification]="locationQualification"
                    [quotas]="locationQualification.quotas"
                    [flexible]="locationQualification.flexible"
                    [changeCompletes]="changeQuotaDistribution"
                    [clickBalance]="form.value.clickBalancing"
                    [deleteQuotas]="deleteLocationQuotas"
                    [isQlcLiveSurvey]="isQlcLiveSurvey"
                    (selectionChange)="setLocationQualification($event)"
                    (quotaChange)="setQuotas($event)"
                    [hasNestedGroup]="hasNestedGroup"
                    [isLiveSurveyEdit]="isLiveSurveyEdit"
                    [clearLocationData]="clearLocationData"
                  >
                  </ps-ui-search-location-qualification>
                </ng-container>
                <ng-container
                  *ngSwitchCase="QUALIFICATIONS_RENDER_TYPE.FILE_UPLOAD"
                >
                  <ps-ui-upload-location-qualification
                    *ngIf="locationQualification.is_location"
                    [complete]="totalClicks || form.value.numberOfCompletes"
                    [selectedCountry]="selectedCountryCode"
                    [surveyId]="surveyId"
                    [qualification]="locationQualification"
                    [clickBalance]="form.value.clickBalancing"
                    [changeCompletes]="changeQuotaDistribution"
                    [quotas]="locationQualification.quotas"
                    [flexible]="locationQualification.flexible"
                    [deleteQuotas]="deleteLocationQuotas"
                    [isQlcLiveSurvey]="isQlcLiveSurvey"
                    (selectionChange)="setLocationQualification($event)"
                    (quotaChange)="setQuotas($event)"
                    [hasNestedGroup]="hasNestedGroup"
                    [isLiveSurveyEdit]="isLiveSurveyEdit"
                    [clearLocationData]="clearLocationData"
                  >
                  </ps-ui-upload-location-qualification>
                </ng-container>
              </ng-container>
            </ng-template>
          </ps-ui-tab>
        </ps-ui-tab-group>
      </div>
      <div class="quota-border"></div>
      <div class="nested-quotas">
        <div class="quota_btn">
          <button
            (click)="openQuotaNestingModal()"
            type="button"
            class="nested-quotas-button btn btn-default btn-link clear-button ms-0"
            [disabled]="isQlcLiveSurvey"
          >
            Quota Nesting
          </button>
          <div *ngIf="nestedQuotasActive">
            <span class="has-quota-label has-nesting"> (Has Nesting) </span>
          </div>
        </div>

        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="hasMoreQuotasThanCompletes"
        >
          There are more quotas than completes available. Some nested quotas
          have 0 quantity available. This may cause unexpected behavior - please
          revise nested quotas if this warning is unexpected.
        </div>
      </div>
    </div>
  </form>
  <ps-ui-right-slider-window
    *ngIf="!isInsight"
    (purePriceApplied)="applyPurePrice($event)"
    (purePriceV2Applied)="applyPurePriceV2($event)"
    [surveyDetails]="surveyDetails"
    [surveyPayload]="surveyPayload"
    [purePriceData]="purePriceData"
    [hasQuotasForPurePrice]="quotasForPurePrice"
    [isTCSPAEditMode]="isTCSPAEditMode"
    [countries]="countries"
    [selectedTemplateId]="selectedTemplateId$ | async"
    (mcSurveyAdded)="informOnMcSurveyAdded()"
    (cancelTemplateSelection)="onCancelTemplateSelection()"
    [showFlyoutWindow]="showFlyoutWindow"
    [unicornQuotas]="unicornQuotas"
    [difficultQuotas]="difficultQuotas"
  ></ps-ui-right-slider-window>
</main>
<ps-ui-footer
  [class.d-none]="isInsight"
  [isInsight]="isInsight"
  [buttonStatus]="footerButtonStatus"
  [surveyPayload]="surveyPayload"
  [currentPage]="'AUDIENCE'"
  [manualProcessing]="manualProcessing"
  [templateResponse]="selectedTemplateResponse"
  (updatedTemplate)="updateTemplate($event)"
  [waspBuyerCpiOverrideState]="buyerCpiConfirmation.state"
></ps-ui-footer>
